import {LOG_LEVEL} from './logger-levels';

// This will check if a cookie is setup with the level of debugging information. If the cookie is present and have the debugging level then use this level...
const getLevel = (level) => {
    try{
        if (document) {
            let name = 'IOL_logging_level=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            let cookieContent = '';
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') {
                c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                cookieContent = c.substring(name.length, c.length);
                }
            }
    
            switch(cookieContent.toLowerCase()){
                case 'debug':
                    return LOG_LEVEL.DEBUG;
                case 'warning':
                    return LOG_LEVEL.WARNING;
                case 'error':
                    return LOG_LEVEL.ERROR;
                case 'fatal':
                    return LOG_LEVEL.FATAL;
                default:
                    return level;
            }
        }
        return level;
    }
    catch(ex){
        // Something happen with cookie - just ignore it and return level
        return level;
    }
}

const getConfigLevel = (configLevel) => {
    try
    {
        // get level from Environment Variable:
        let level = parseInt(configLevel);
        if (isNaN(level)) {
          return 0;
        }
        return level
    }
    catch(ex){
        // something is not setup correctly on the log level - return OFF for security so nothing will appear on console.log
        return 0;
    }
}

export const loggingConfig = {
    // This will set the level you want to log to the Console.log: OFF in prod - DEBUG in other mode
    // level for log to console cannot be overwritten by a cookie - this is to ensure that no sensitiv information is logged on console on the client computer 
    // instead the overwritten debug level can be logged in to AppInsight which can only be viewed when logged in...
    logToConsole: getConfigLevel(process.env.VUE_APP_ConsoleLogLevel),

    // This will set the level you want to log to AppInsight: ERROR inm prod - OFF in other mode.
    // Error level can be overwritten through a cookie present on the browser.
    // The additional debug info will be logged to the server where the access to read is secured - this is to avoid any security risks
    logToServer: getLevel(getConfigLevel(process.env.VUE_APP_ServerLogLevel)),
    applicationName: "Investor Online"
};

